import styled from 'styled-components';

const StyledMedicineSelector = styled.div`
   position: relative;
   display: flex;
   flex-direction: column;
   height: 100%;
   gap: 12px;
`;

StyledMedicineSelector.displayName = 'StyledMedicineSelector';

export { StyledMedicineSelector };
